import { createStyles, makeStyles } from "@material-ui/core/styles";
import peopleImage from "assets/icons/black-businessman-30.svg";
import mypapsLogo from "assets/icons/MYPAPSLOGO.svg";
import papsChristmasLogo from "assets/images/Paps_Noel.svg";
import useText from "constants/text";
import React from "react";
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      width: "100%",
      textAlign: "center",
      justifyContent: "center",
      "*": {
        margin: 5,
      },
    },
    top: {
      flex: 2,
      background: "#1b224b",
    },
    bottom: {
      flex: 3,
    },
    display: {
      margin: 20,
      paddin: 20,
      position: "relative",
      display: "flex",
      justifyContent: "center",
    },
    card: {
      color: "#9094a9",
      background: "#fff",
      height: "auto",
      position: "absolute",
      padding: 10,
      borderRadius: 15,
      width: "25rem",
      top: 60,
    },
    logo: {
      margin: 5,
    },
    textContent: {
      margin: 5,
      textAlign: "justify",
    },
    urls: {
      marginRight: "auto",
      textAlign: "left",
      marginTop: 20,
      display: "flex",
      justifyContent: "space-evenly",
      flexDirection: "column",
    },
    url: {
      marginTop: 15,
      marginBottom: 15,
    },
    new: {
      color: "#1f264e",
    },
    link: {
      color: "#389ebf",
    },
    b: {
      color: "#1f264e",
    },
  })
);

export function RedirectPage() {
  const styles = useStyles();
  const { text } = useText();
  const logo = process.env.REACT_APP_PAPS_GIFT === "true" ? papsChristmasLogo : mypapsLogo;
  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <div className={styles.display}>
          <div className={styles.logo}>
            <img src={logo} alt="mypaps logo" />
          </div>
          <div className={styles.card}>
            <div>
              <img src={peopleImage} alt="busness" />
            </div>
            <div className={styles.textContent}>
              <p>{text.redirect_page.greetings}</p>
              <p>{text.redirect_page.intro}</p>
              <p>
                {text.redirect_page.message} <b className={styles.b}>{text.redirect_page.date}</b>.
              </p>
              <p>{text.redirect_page.bookmark}</p>
              <div className={styles.urls}>
                <div className={styles.url}>
                  <div>
                    <b>{text.redirect_page.current_url}</b>
                  </div>
                  <div>
                    <a href="#">https://myapps.paps.sn</a>
                  </div>
                </div>
                <div className={styles.url}>
                  <div className={styles.new}>{text.redirect_page.new_url}</div>
                  <a className={styles.link} href="https://mypaps.paps.sn">
                    https://mypaps.paps.sn
                  </a>
                </div>
                <div className={styles.url}>
                  <div>{text.redirect_page.closing}</div>
                  <div>{text.redirect_page.signature}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>bottom</div>
    </div>
  );
}
